var app = angular.module('directives.paymentGroups');

app.directive('paymentGroups', [
    'configs',
    '$state',
    '$rootScope',
    '$stateParams',
    function(configs, $state, $rootScope, $stateParams) {
        var tmplUrl;

        try {
            tmplUrl = require('../templates/'+$state.current.name.replace('pages.','')+'.html');//looking for template with moduleName
        }catch(e){
            tmplUrl = require('../templates/index.html')//if error, use default template
        }

        var parsedLink = $state.current.url.split("/");
        parsedLink.forEach(function(key) {
            if (key == 'l') {
                tmplUrl = require('../templates/index.html');
            }
            if (key == 'ls') {
                tmplUrl = require('../templates/service.html');
            }
        });
        return {
            template: tmplUrl,
            controller:'groupCtrl',
            scope: {
                'step': '@',
                'groups': '=',
                'form': '='
            },
            link: function(scope, element, attrs, ctrl) {
            }
        }

    }
]);

app.controller('groupCtrl',function ($scope, Pay, $rootScope, $stateParams) {
   $scope.pay = Pay;

   $scope.selectGroup = function (group, step) {
       // Блокуємо зміну груп якщо поточний стан не відповідає кроку директиви
       if ($scope.pay.innerState !== $scope.step) {
           return;
       }

       //for checkbox logic - value can be unchecked
       // if ($scope.pay.selectedGroup[step] && ($scope.pay.selectedGroup[step].alias == group.alias)) {
       //     $scope.pay.selectedGroup[step] = {}
       //     $scope.groups.forEach(function(g) {
       //         if (g.alias == group.alias) {
       //             g.selected = false;
       //         }
       //     })
       // } else {
       //     for (var i = 0; i < $scope.groups.length; i++) {
       //         if ($scope.groups[i].alias == group.alias) {
       //             $scope.groups[i].selected = true;
       //             $scope.pay.selectedGroup[step] = $scope.groups[i];
       //         } else {
       //             $scope.groups[i].selected = false;
       //         }
       //     }
       // }

       //radio logic - value cannot be unchecked
       for (var i = 0; i < $scope.groups.length; i++) {
           if ($scope.groups[i].alias == group.alias) {
               $scope.groups[i].selected = true;
               $scope.pay.selectedGroup[step] = $scope.groups[i];
           } else {
               $scope.groups[i].selected = false;
           }
       }

       const totalAmountFieldInGroup = group.fields.find(function(field) {
           return field.alias === 'TOTAL_AMOUNT'
       });

       if(totalAmountFieldInGroup && totalAmountFieldInGroup.value && !$stateParams.amount) {
           if (totalAmountFieldInGroup.type == 'AMOUNT' &&
               totalAmountFieldInGroup.alias === 'TOTAL_AMOUNT' &&
               totalAmountFieldInGroup.value &&
               totalAmountFieldInGroup.restriction === 'RO' &&
               totalAmountFieldInGroup.value/100 >=  $scope.pay.service.amount_min &&
               totalAmountFieldInGroup.value/100 <=  $scope.pay.service.amount_max
           ) {
               $scope.pay.amount =  $scope.pay.amountInput = (totalAmountFieldInGroup.value/100).toString();
               $scope.pay.amountInputRO = true;
           }

           $scope.pay.amount = totalAmountFieldInGroup.value / 100;
           $scope.pay.amountInput = totalAmountFieldInGroup.value / 100;
       } else {
           $scope.pay.amountInputRO = false;
           $scope.pay.amount = 0;
           $scope.pay.amountInput = 0;
           $scope.pay.amountWithCommission = 0;
       }

       $rootScope.$broadcast('countAmount');
   }

   $scope.isStepActive = function() {
       return $scope.pay.innerState === $scope.step;
   };

   function init () {
       for (var i = 0; i < $scope.groups.length; i++) {
           if ($scope.groups[i].selected) {
               $scope.pay.selectedGroup[$scope.step] = $scope.groups[i];
               break;
           }
       }
   }

   $scope.$watch('groups', function(newGroups, oldGroups) {
        if (newGroups && newGroups.length > 0) {
            init();
        }
    }, true);

   init();
});



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/paymentGroups/directives/paymentGroups.js
 ** module id = 205
 ** module chunks = 1
 **/